/**
 * Check if the current number has reached the maximum capacity of the series
 * @param currentNumber - The current number in the series
 * @param maxDigits - The maximum number of digits supported (length of zeros in pattern)
 * @returns True if the series has reached its maximum capacity
 */
export const isSeriesAtMaximum = (currentNumber: number, maxDigits: number): boolean => {
  const maxValue = Math.pow(10, maxDigits) - 1
  return currentNumber > maxValue
}

/**
 * Extract the last number from the pattern and the last generated serial
 * @param pattern - The pattern to extract the last number from. Example INV-{000000}-CN
 * @param lastGeneratedSerial - The last generated serial to extract the last number from. Example INV-020751-CN
 * @returns The last number 20751
 */
export const getLastNumber = (pattern: string, lastGeneratedSerial: string): number => {
  const match = pattern.match(/\{(0+)\}/)
  if (!match || !match[1]) return 0

  const zeros = match[1]

  const start = pattern.indexOf(`{${zeros}}`)
  if (start === -1) return 0

  const prefix = pattern.slice(0, start)
  const prefixLength = prefix.length

  const numberStr = lastGeneratedSerial.substring(prefixLength, prefixLength + zeros.length)

  return Number(numberStr.replace(/^0+/, '')) || 0
}
